import _has from 'lodash/has';

const valueMatchesItem = (value, item) => {
  let displayValueMatches = false;
  let valueMatches = false;

  if (_has(item, 'displayValue')) {
    displayValueMatches = item.displayValue.toLowerCase().includes(value.toLowerCase())
      && item.displayValue.length >= value.length;
  }

  if (_has(item, 'value')) {
    valueMatches = item.value.toLowerCase().includes(value.toLowerCase())
      && item.value.length >= value.length;
  }

  return displayValueMatches || valueMatches;
};

const alreadySelected = (item, currentItems) => currentItems.map(i => i.id).indexOf(item.id) !== -1;

const getSuggestedItems = (value, availableItems, currentItems) => {
  const result = [];

  if (availableItems) {
    result.push(...(availableItems.filter(item => valueMatchesItem(value, item))));
  }

  if (Array.isArray(currentItems)) {
    return result.filter(item => (!alreadySelected(item, currentItems)));
  }

  return result;
};

export default getSuggestedItems;
